import axios from "axios";
import Backdrop from "../../Catalogs/Dialog/Backdrop";
import { CategorySelector } from "../../Catalogs/Dialog/CategorySelector";
import styles from "./CartDetails.module.css";
import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../../config";

export const CreateProductDialog = ({
  show = false,
  onClose = () => {},
  onManual = () => {},
  onAddLink = () => {},
  onSuccess = () => {},
  onStartUpload = () => {},
  onEndUpload = () => {},
}) => {
  const { cartId } = useParams();
  const [mode, setMode] = useState("choice");
  const [productLink, setProductLink] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const navigate = useNavigate();

  if (!show) return null;

  const handleClose = () => {
    setMode("choice");
    setProductLink("");
    setSelectedCategoryId("");
    onClose();
  };

  const createProductFromUrl = async () => {
    try {
      const response = await axios.post(
        `${API}/Admin/carts/${cartId}/product/url`,
        {
          url: productLink,
          category: selectedCategoryId || "",
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Product created from link");
        const productId = response.data.product._id;
        console.log({ res: response.data });
        navigate(`/products/${productId}`);
        return true;
      }
      toast.error("Failed to create product from url");
      return false;
    } catch (error) {
      console.error("Failed to create product from url:", error);
      toast.error("Failed to create product from url");
      return false;
    }
  };

  const handleManualClick = () => {
    onManual();
    handleClose();
  };

  const handleAddLinkClick = async () => {
    const trimmed = productLink.trim();
    if (!trimmed) {
      toast.error("Please enter a product link");
      return;
    }
    onStartUpload();
    handleClose();
    const success = await createProductFromUrl();
    onEndUpload();

    if (!success) return;

    onSuccess();
    onAddLink({
      link: trimmed,
      categoryId: selectedCategoryId || "",
    });
  };

  return (
    <div>
      <Backdrop show={show} switch={handleClose} />
      <div className={styles.createProductDialog}>
        <h2 className={styles.createProductTitle}>Create New Product</h2>
        <p className={styles.createProductSubtitle}>
          How do you want to add the product?
        </p>

        {mode === "choice" ? (
          <div className={styles.createProductButtonsRow}>
            <button
              type="button"
              className={styles.createProductOptionButton}
              onClick={handleManualClick}
            >
              Manually
            </button>
            <button
              type="button"
              className={styles.createProductOptionButton}
              onClick={() => setMode("link")}
            >
              Add Link
            </button>
          </div>
        ) : (
          <div className={styles.createProductLinkContainer}>
            <CategorySelector
              value={selectedCategoryId}
              onChange={setSelectedCategoryId}
              placeholder="Select category"
              fieldName="category"
              error={false}
              submitted={false}
              styles={styles}
            />
            <input
              type="text"
              className={styles.createProductLinkInput}
              placeholder="Paste product link here"
              value={productLink}
              onChange={(e) => setProductLink(e.target.value)}
            />
            <button
              type="button"
              className={styles.createProductPrimaryButton}
              onClick={handleAddLinkClick}
            >
              Add Product
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
